module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderWarehouse.title')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderWarehouse.title')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.orderWarehouse",
      "hasLabel": true
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.store($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a31bffb","hasScoped":false}!./src/app/components/orderWarehousePopup/orderWarehousePopup.html
// module id = 3071
// module chunks = 1